import { Badge } from '@startupquickstart/frontend';

interface SpeedBonusBadgeProps {
  speedBonuses: number[];
}

/** Badge showing speed bonus tiers (e.g. "Speed Bonus: 50/30/10") */
export function SpeedBonusBadge({ speedBonuses }: SpeedBonusBadgeProps) {
  if (!speedBonuses || speedBonuses.length === 0) return null;

  return (
    <Badge variant="outline" className="text-xs px-1.5 py-0 h-5 text-blue-600 border-blue-300">
      Speed Bonus: {speedBonuses.join('/')}
    </Badge>
  );
}
